// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-Mwz","col":"styles_col__1uY9b"};